import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5","key":"svg-0"}],["path",{"d":"M9 17h3.5","key":"svg-1"}],["path",{"d":"M16 19h6","key":"svg-2"}],["path",{"d":"M19 16v6","key":"svg-3"}]]

const IconDeviceIpadHorizontalPlus = createReactComponent('outline', 'device-ipad-horizontal-plus', 'DeviceIpadHorizontalPlus', __iconNode);

export default IconDeviceIpadHorizontalPlus;